import { createSelector } from 'reselect';
import { RootState } from '../index';

const userReducerSelector = (state: RootState) => state.user;
const platformReducerSelector = (state: RootState) => state.platform;

export const platform_lastLoginPlatform = createSelector(userReducerSelector, (user) => {
    const sortedPlatforms = user.userInfo.tradingPlatformAccounts?.sort((a, b) => {
        const dateA = new Date(a.lastLoginTime || 0).getTime();
        const dateB = new Date(b.lastLoginTime || 0).getTime();
        return dateB - dateA;
    });
    if (!sortedPlatforms || sortedPlatforms.length === 0) return undefined;
    return sortedPlatforms[0];
});

export const platform_getPlatformByName = (state, accountName: string) =>
    createSelector(userReducerSelector, (user) =>
        user.userInfo.tradingPlatformAccounts?.find((account) => account.name === accountName)
    )(state);

export const platform_iframeUrl = createSelector(platformReducerSelector, (platform) => {
    return platform.platformIframeUrl;
});

export const platform_iframeUrlLodaer = createSelector(
    platformReducerSelector,
    (platform) => platform.platformIframeUrlLoading
);

export const platform_wnstnToken = createSelector(platformReducerSelector, (platform) => platform.wnstnToken);
